
<canvas ref="lineChart"></canvas>

<script>
import { Line } from 'vue-chartjs';

export default {
    extends: Line, // Extend the base Line chart component

    props: ['chartData', 'chartOptions'],

    mounted() {
        this.renderChart(this.chartData, this.chartOptions);
    }
};
</script>
  